<div class="memic-panel panel">
  <div class="panel-heading">
    <h3 class="panel-title">Training Events</h3>
  </div>
  <div class="panel-body">
    <div *ngIf="!events">
      <em>Loading Events...</em>
    </div>
    <ul class="memic-list memic-list--details memic-list--brdless list-group m-a-0" *ngFor="let e of events; index as i;">
      <li class="memic-list__body list-group-item p-x-0">
        <div class="memic-list__body-left">
          <div class="list-group-item__tile">
            <span class="header">{{e.eventDate | date:'d'}} <span *ngIf="showEndDate(e)" >- {{e.endDate | date:'d'}}</span></span>
            <span class="content">{{e.eventDate | date:'MMM yyyy'}}</span>
          </div>
        </div>
        <div class="memic-list__body-right">
          <header class="memic-list__header">
            <h2 class="memic-list__title"><a href="{{e.link}}" (click)="trainingEventClick(e.link)" target="_blank">{{e.title}}</a></h2>
          </header>
          <span class="memic-tag m-b-1">{{e.eventDate | date:'hh:mm a'}} - {{e.endDate | date:'hh:mm a'}}</span>
          <div class="memic-list__content">
            {{e.calendarDescription}}
          </div>
        </div>
      </li>
    </ul>
    <div *ngIf="events && events.length > 0">
      <div class="card-footer memic-card-footer text-muted">
        <a href="javascript:void(null)" [ngClass]="{'disabled': tap <= 0}" class="btn memic-btn-link memic-btn-link--primary pull-left" (click)="prevPage()">
          <i class="fas fa-chevron-left" aria-hidden="true"></i>
          Previous
        </a>
        <a href="javascript:void(null)" [ngClass]="{'disabled': tap >= totalEventsBatch - 1}" class="btn memic-btn-link memic-btn-link--primary pull-right" (click)="nextPage()">
          Next
          <i class="fas fa-chevron-right" aria-hidden="true"></i>
        </a>
      </div>
    </div>
    <div *ngIf="events && events.length == 0">
      <em>Checkback Soon For Upcoming Events</em>
    </div>
  </div>
</div>
